import { Formik, FormikHelpers, FormikProps } from "formik";
import React, { MutableRefObject } from "react";

import { FormRender, OnFormSubmit, ValidateForm } from "./form-t";

const DEFAULT_FORM_SUBMIT: OnFormSubmit = () => {};

interface FormProps {
  defaultValue?: any;
  validateForm?: ValidateForm;
  onSubmit?: OnFormSubmit;
  className?: string;
  children: FormRender;
  id?: string;
  validationSchema?: any | (() => any);
  // Exposes the underlying Formik instance to parents that need to coordinate
  // multiple independent forms (e.g. merge values across split sections before PATCH).
  innerRef?: MutableRefObject<FormikProps<any> | null>;
}

function Form(props: FormProps) {
  const {
      id,
      defaultValue = {},
      validateForm,
      onSubmit = DEFAULT_FORM_SUBMIT,
      validationSchema,
      className,
      children,
      innerRef,
    } = props,
    _onSubmit = async (values: any, form: FormikHelpers<any>) => {
      const formattedValues = validationSchema
        ? validationSchema.cast(values, { assert: false })
        : values;

      onSubmit(formattedValues, form);
    };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={defaultValue}
      // NOTE: Kept intentionally (do not remove): used by pages that merge values from
      // multiple forms at submit time without changing UI/UX.
      innerRef={innerRef ?? undefined}
      onSubmit={_onSubmit}
      validate={validateForm}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, ...rest }) => (
        <form
          className={className}
          id={id}
          onSubmit={handleSubmit}
        >
          {children(rest)}
        </form>
      )}
    </Formik>
  );
}

export default Form;
